<template>
    <div class="my-profile">
        <mt-header fixed title="服务点信息">
            <router-link to="/" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">

            <mt-field label="服务点名称" type="text" v-model="stationName" disabled></mt-field>
            <mt-field label="服务点简介" placeholder="请输入服务点简介" type="textarea" v-model="desc"></mt-field>

            <div class="mint-checklist">
                <label class="mint-checklist-title">服务点图片</label>
                <div class="worker-photo" v-if="worker_photo_exist">
                    <img :src="worker_photo_url" class="worker-photo-img">
                </div>
                <uploader @getFiles='getImageList' @removeFiles='removeImage'></uploader>
            </div>

            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="updateStation">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<style>
    .worker-photo{
        padding:10px;
    }
    .worker-photo-img{
        width:100%;
        height:200px;
    }
</style>
<script>
    import mintSelect from '../../components/mintSelect.vue'
    import uploader from "../../components/upload"
    import GlOBAL from "@/api/global"

    export default{

        components: {
            'mint-select':mintSelect,
            'uploader':  uploader
        },

        data(){
           return {
               userInfo:JSON.parse(window.localStorage.getItem('UserInfo')),

               stationName:'',
               desc:'',
               worker_photo_exist:false,
               worker_photo_url:'',

               imgUrl:GlOBAL.imgUrl,
               imgList: [], //已上传的图片集合
           }
        },
        methods:{
            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },

            updateStation(){

                let that = this;

                if(this.imgList.length>0){
                   this.worker_photo_exist = false;
                }

                if(this.imgList.length>1){
                    this.$toast('仅支持上传1张图片！');
                    return false;
                }


                this.$indicator.open('加载中');


                this.$axios.post("/my/station", {openid:this.userInfo.openid,thumb:this.imgList,worker_photo_exist:this.worker_photo_exist,desc:this.desc})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('修改成功!');
                            setTimeout(function(){
                                that.$router.push('/');
                            },2000);
                        } else {
                            this.$toast(data.data.message);
                        }
                    });

            },

            getImageList(files) {
                this.$nextTick(() => {

                    for (let i = 0, len = files.length; i < len; i++) {

                        this.imgList.push(files[i].src.split("base64,")[1]);
                        //上传图片
                        //   this._getFileCode({
                        //     Base64Str: files[i].src.split("base64,")[1],
                        //     AttachmentType: this.$enums.AttachmentType.Activity
                        //   });
                    }
                });
            },
            //删除图片
            removeImage(index) {
                this.imgList.splice(index, 1);
            },

            //上传图片获取fileCode (目前该方法没调用，供参考)
            _getFileCode(obj) {
                // Indicator.open(this.lang.dynamic_publishing);
                this.$http
                    .post(this.$profileApi.Shared_UploadImage, obj)
                    .then(data => {
                        if (data.Rstatus) {
                            this.FilecodeList.push(data.Rdata);
                        } else {
                            // Toast(this.lang.dynamic_upload_fail);
                        }
                    })
                    .catch(err => {
                        //   Toast(this.lang.dynamic.dynamic_net_error);
                    });
            },

        },

        created(){
            this.$axios.get('/my/station?openid='+this.userInfo.openid)
                .then(data => {

                    if (data.data.code === 'OK') {
                        let r = data.data.data;

                        this.desc = r.desc;
                        this.stationName = r.name;

                        if(r.thumb!==''&&r.thumb!==null){
                            this.worker_photo_exist = true;
                            this.worker_photo_url = this.imgUrl+'uploads/'+r.thumb;

                        }

                    } else {
                        this.$toast(data.data.message);
                    }
                });

        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/my/station.vue